// Keeps an expanded loan card in sync with the freshly loaded dashboard.
// Returning null is intentional: a loan that no longer exists must not retain
// a stale detail card.
export const selectedLoanFromDashboard = (selected, dashboard) => {
  if (!selected) return null;
  return (dashboard?.loans || []).find((loan) => loan.id === selected.id) || null;
};
